import React from 'react';
import { IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material'


export default class Input extends React.Component {
    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }

    changeHandle = e => {
        this._isMounted = true;
        let value = e.target.value;
        let fieldName = e.target.id;
        if(this._isMounted) this.props.onChange(fieldName,value);
    }

    render() {
        let {type,id,value,placeholder,className,font,customStyle,isRTL, _visiblePwd} = this.props;
        const passwordIconStyle = isRTL === 'ar' ? {left:0} : {right:0};
    return (['password','signupPassword']?.includes(id) ? <div style={{position:'relative'}}>
        <input 
            type={type}
            value={value}
            id={id} 
            onChange={this.changeHandle}
            placeholder={placeholder}
            className={className}
            style={{fontFamily:font || 'inherit',...customStyle}}
            autoComplete='off || disabled'
        />
        <IconButton style={{ position:'absolute',top:-3,...passwordIconStyle }} size="large">
            {type === 'password' ?
                <Visibility className='icon' style={{color:'#0F467A'}} onClick={_visiblePwd}/>
                :
                <VisibilityOff className='icon' onClick={_visiblePwd}/>
            }
        </IconButton>
    </div> : <input 
        type={type}
        value={value}
        id={id} 
        onChange={this.changeHandle}
        placeholder={placeholder}
        className={className}
        style={{fontFamily: font || 'inherit',...customStyle}}
        autoComplete='off || disabled'
    />);
    }
}